import axios from '@/axios.js'

const cookie = {
  getCookie () {
    return axios.get('/sanctum/csrf-cookie')
  },
}
export default cookie
